// src/services/blockedIps.js
const API_PROXY_SCRIPT = "https://api.sobevenda.com.br/api-proxy/script";

function getAuthHeaders() {
  const token = localStorage.getItem("sobevenda_token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

function buildQuery(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    const s = String(v).trim();
    if (!s) return;
    qs.set(k, s);
  });
  const str = qs.toString();
  return str ? `?${str}` : "";
}

// ✅ Ajuste aqui se seus endpoints no Xano tiverem outro nome
const ROUTES = {
  // listagem com filtros opcionais: scope, script_uuid, active
  list: `${API_PROXY_SCRIPT}/blocked-ips`,
  // criar
  create: `${API_PROXY_SCRIPT}/blocked-ips`,
  // toggle active (PATCH)
  patch: (id) => `${API_PROXY_SCRIPT}/blocked-ips/${id}`,
  // delete (opcional)
  del: (id) => `${API_PROXY_SCRIPT}/blocked-ips/${id}`,
  // scripts do usuário (pra dropdown)
  scripts: `${API_PROXY_SCRIPT}/list-sobescripts-active`,
};

export async function getBlockedIps({ scope, script_uuid, active } = {}) {
  const url = ROUTES.list + buildQuery({ scope, script_uuid, active });
  const res = await fetch(url, { method: "GET", headers: getAuthHeaders() });
  if (!res.ok) throw new Error(`Falha ao buscar bloqueios (${res.status})`);
  return res.json();
}

export async function createBlockedIp({ ip, scope, script_uuid, note } = {}) {
  const res = await fetch(ROUTES.create, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ ip, scope, script_uuid, note }),
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Falha ao criar bloqueio (${res.status}) ${txt}`);
  }
  return res.json();
}

export async function patchBlockedIp(id, payload = {}) {
  const res = await fetch(ROUTES.patch(id), {
    method: "PATCH",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Falha ao atualizar bloqueio (${res.status})`);
  return res.json();
}

export async function deleteBlockedIp(id) {
  const res = await fetch(ROUTES.del(id), {
    method: "DELETE",
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error(`Falha ao remover bloqueio (${res.status})`);
  return res.text().catch(() => "");
}

export async function getMyScripts() {
  const res = await fetch(ROUTES.scripts, { method: "GET", headers: getAuthHeaders() });
  if (!res.ok) throw new Error(`Falha ao buscar scripts (${res.status})`);
  return res.json();
}
